import { useMemo, useState } from "react";
import { getSinglePost } from "../contentful";

export default function useSinglePost(slug) {
  const [post, setPost] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useMemo(() => {
    const fetchPost = async () => {
      setLoading(true);
      try {
        const result = await getSinglePost(slug);
        setPost(result[0].fields);
      } catch (error) {
        console.error("Error fetching post:", error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPost();
    }
  }, [slug]); // Dependency array includes slug

  return [post, isLoading];
}
